export default __webpack_public_path__ + "static/media/myBoard-icon.86209c57.svg";